const baseURL = process.env.REACT_APP_API_ENDPOINT + "api/v1/";
const firebasePublicKey = "BPeqNYl5OHdf7UXkCmqpO9q532W9koj2z50IQMUrpt_gGhc8o-x6MoRWNbGDTpaBamwUrMvfHFEhih0cnd78yo0";

export { baseURL,firebasePublicKey };
